<template>
<v-layout class="reset-password-page" column justify-center align-center>

  <div v-if="this.showSpecialtyLogo" class="logo">
        
          <img style="margin-top:16px" :src="this.showSpecialtyLogo" height="50" alt="">
        </div>
        
        <div v-else class="logo" router >
        
          <i  class="material-icons" style="padding:7px; margin-right:20px; backgroundColor:#4485ed;border-radius:50%; color:#E6E6E8">folder</i>
          <div class="logo-title">OneChart</div>
        </div>

  <v-layout v-if="authUser" column>
   <v-card v-if="sent" flat color="transparent">
      <v-card-text>
        <v-layout justify-center align-center>
          <i class="material-icons check-icon">check_circle</i>
        </v-layout>
        <div class="content">{{$t('auth.sendResetPasswordSent')}}</div>
        <div class="email">{{authUser.email || $t('auth.noEmail')}}</div>
      </v-card-text>
    </v-card>

    <v-card v-else class="card" flat color="transparent">
      <v-card-text>
        <div class="content">{{$t('auth.sendResetPasswordContent')}}</div>
        <div class="email">{{authUser.email  || $t('auth.noEmail')}}</div>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="authUser.email" depressed :loading="sending" 
        style="width:100%" color="primary" @click="reset()">{{$t('auth.sendResetPassword')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-layout>

  <v-progress-circular v-else class="busy" indeterminate :size="50" color="primary"></v-progress-circular>
  

</v-layout>
</template>

<style lang="scss" scoped>
.reset-password-page {
  padding-top: 24px;
}

.busy {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%)
}

.card {
  max-width: 520px;
  width: 100%;
}

.logo {
  display: flex;
  align-items: center;
  font-size: 28px;
  padding: 10px 24px;
  border-radius: 8px;
  text-transform: uppercase;
  cursor: pointer;
  letter-spacing: 7px;
  font-weight: 300;
  .logo-icon {
    margin-right: 5px;
    font-size: 40px;
  }
}

.onechart {
  font-size: 48px;
  margin-right: 4px;
}

.email {
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  padding: 8px;
  margin-bottom: 24px;
}

.content {
  padding-top: 18px;
  padding-bottom: 32px;
}

.check-icon {
  font-size: 88px;
  color: #8bc34a;
}
</style>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return {
      sending: false,
      sent: false
    }
  },
  computed: {
    ...mapState('auth', ['authUser']),
    showSpecialtyLogo() {
      if (window.location.host.includes('smartchoice')) {
        return 'https://storage.googleapis.com/onechart-assets/sclogo.png'
      } else if (window.location.host.includes('grayhawk')) {
        return 'https://storage.googleapis.com/onechart-assets/logos/1699131904.png'
      } else {
        return null
      }
    }
  },
  methods: {
    ...mapActions('auth', ['resetPassword']),
    reset() {
      this.sending = true
      this.resetPassword({
        email: this.authUser.email
      }).then(() => {
        this.sent = true
        this.sending = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/auth/ResetPasswordPage.vue